import eventBus from '@/tools/eventBus';

export const modalMixin = {
    methods: {
        openModal(e) {
            eventBus.$emit('open', e);
        }
    }
};
